import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { WorkspacesView } from "src/components/views/workspaces/WorkspacesView.tsx";
import { useKeptAliveView } from "src/routing/keepAlive/keptAliveView.ts";

export const Route = createFileRoute("/_authenticated/_shell/workspace/workspaces")({
	staticData: { title: i18n.t("workspaces"), legacyViewKey: "workspacesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	const { isActive } = useKeptAliveView();
	return <WorkspacesView isActive={isActive} />;
}
